export const APP_NAME = "NYPD Hispanic Society";
export const APP_ADMIN_TITLE = "NYPD Hispanic Society - Admin";
export const APP_TITLE = "NYPD Hispanic Society - Admin Dashboard";
export const APP_FULL_NAME = "NYPD Hispanic Society";
